import { memo } from 'react';
import type { PostStory } from '../../../content/types/types';
import { VStack } from '../../../library';
import PostItem from './PostItem/PostItem';

const PostsList = ({ items }: { items: PostStory[] }) => {
    return (
        <VStack gap="micro">
            {items.map(post => (
                <PostItem post={post} key={post.slug} />
            ))}
        </VStack>
    );
};

export default memo(PostsList);
